export default "assets/images/footer-partners-logos-6efa7b0d.png";